














































































  import Vue from 'vue';
  import Component from 'vue-class-component';

  @Component({
    name: 'buyMobil',
    components: {},
    mixins: [],
  })
  export default class buyMobil extends Vue {
    public created(): void {
      // on componenet created
    }
    public mounted(): void {
      // on componenet mounted
    }
  }
